import Rest from '../Rest'

/**
 * Agenda do Mural.
 *
 * O escopo (estabelecimento ou professor) é resolvido no servidor a partir do
 * vínculo do usuário — o cliente não escolhe e nem precisa saber. Por isso não
 * há parâmetro de clube aqui: quem manda é o header `SCD-Data-Access` que o
 * interceptor já envia.
 */
export default class AgendaService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/agenda'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  /** Grade expandida da janela: ficha das aulas + dias com slots e ocupação. */
  getOccurrences(startDate: string, days: number = 7) {
    return this.get(`/occurrences?start_date=${startDate}&days=${days}`)
  }

  /**
   * Indicadores do período. Receita e "Últimas vendas" só voltam para quem tem
   * `financial.dashboard.menu` — a ausência das chaves é o sinal de que o
   * usuário não pode ver valores.
   */
  getSummary(startDate: string, endDate: string) {
    return this.get(`/summary?start_date=${startDate}&end_date=${endDate}`)
  }
}
